export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_48-096258aa0c95a410249aaed9b4056039.jpg";